module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAICAYAAAAvOAWIAAAAiElEQVQoU2NkwAUKzgswcDMcZvj125Wh2+wFSBkjTsUgiZrz+Qz//2cwvP9oyjDN8Qt+xSAN1ReaGRj+OzC8/+DJyFB5LoSh3WgNQ82FcgaG/ywM3//OZOBi0mb4z+iAsPV/BgMD4xnsijn/6zAwsNhjKsbraHRn4FMM9iBDCsP7D5b4PYgl6ADyzj1vo2zL4wAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/lannest.png
// module id = 7RKS
// module chunks = 0